import type { Amount, FiatPrice } from "@b2bportal/air-booking-api";

export const wallStreetAmountToFiatPrice = (
  amount?: Amount
): Omit<FiatPrice, "currencySymbol"> => ({
  value: amount?.amount || 0,
  currencyCode: amount?.currency || "BRL",
});
